import { render, staticRenderFns } from "./VideoHotcode.vue?vue&type=template&id=f3537cd4&scoped=true&"
import script from "./VideoHotcode.vue?vue&type=script&lang=js&"
export * from "./VideoHotcode.vue?vue&type=script&lang=js&"
import style0 from "./VideoHotcode.vue?vue&type=style&index=0&id=f3537cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3537cd4",
  null
  
)

export default component.exports